import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { IonicModule, IonPopover } from '@ionic/angular';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'src/app/components/components.module';
import { TabsModule } from 'src/app/tabs/tabs.module';
import { Router } from '@angular/router';
import {
  PremiumPage,
  AccountPage,
  InvitePage,
  SharePage,
} from 'src/app/pages';
import {
  CapacitorService,
  FirebaseService,
  EventsService,
  IonicService,
  CacheService,
  HttpService,
  MapboxService
} from 'src/app/services';

@Component({
  selector: 'page-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
  standalone: true,
  imports: [
    IonicModule, CommonModule, FormsModule,
    ReactiveFormsModule, ComponentsModule, TabsModule
  ],
})
export class HomePage implements OnInit {

  @ViewChild('switcher', { static: true }) popover!: IonPopover;

  data: any;
  avatar: string = '';
  type: string = 'Goals';

  //----------------------------------------------------------------------------
  // Constructor
  //----------------------------------------------------------------------------

  constructor(
    public capacitor: CapacitorService,
    public firebase: FirebaseService,
    public events: EventsService,
    public mapbox: MapboxService,
    public ionic: IonicService,
    public cache: CacheService,
    public http: HttpService,
    public router: Router,
    public zone: NgZone,
  ) { }

  //----------------------------------------------------------------------------
  // Initialize
  //----------------------------------------------------------------------------

  async ngOnInit() {
    this.firebase.setScreen('Home');
    this.events.subscribeEvent('home', (sort) => { this.getData(); });
    this.getData();
  }

  ngOnDestroy() {
    this.events.destroyEvent('home');
  }

  //----------------------------------------------------------------------------
  // Get Data
  //----------------------------------------------------------------------------

  async getData() {
    this.zone.run(async () => {
      this.data = await this.http.getRequest('/me');
      this.capacitor.premium = this.data?.premium;
      this.avatar = this.data?.avatar;
    });
  }

  //----------------------------------------------------------------------------
  // Open Popover
  //----------------------------------------------------------------------------

  async openPopover(ev: any) {
    this.firebase.setEvent('home_switch');

    // Present
    this.popover.event = await ev;
    await this.popover.present();
  }

  //----------------------------------------------------------------------------
  // Switch Content
  //----------------------------------------------------------------------------

  async switchContent(value: string) {
    this.firebase.setEvent('home_' + value);

    // Update
    this.data = [];
    this.type = value;
    this.mapbox.mapModal.setCurrentBreakpoint(1);
    await this.popover.dismiss();
    await this.getData();
  }

  //----------------------------------------------------------------------------
  // Open Pages
  //----------------------------------------------------------------------------

  async openPremium() {
    this.firebase.setEvent('home_premium');
    this.ionic.openPage(PremiumPage);
  }

  async openAccount() {
    this.firebase.setEvent('home_account');
    this.ionic.openPage(AccountPage);
  }

  async openShare() {
    this.firebase.setEvent('home_share');
    this.ionic.openPage(SharePage);
  }

  async openNotifications() {
    this.firebase.setEvent('home_notifications');
    this.ionic.openPage(InvitePage);
  }
}